import useClusterSwitchSetting from '../useClusterSwitchSetting'

/**
 * Single route the fabrication order ALIGNMENT switch is read from and written to
 * (`ClusterSendSettingRest:143,164`, verified in Sun on 2026-09-09). Same shape and same gating as
 * part 1's two routes: `GET` needs nothing but an authenticated caller, `PUT` asks for `SETTINGS`.
 */
export const FABRICATION_ORDER_ALIGNMENT_SETTING_ENDPOINT = 'cluster/fabricationOrderAlignmentSetting'

/**
 * S71 (historia 108, RN41″ + P2-DG-28): reads the switch that governs whether this node keeps the
 * orders it already sent aligned.
 *
 * ⚠️ This is **not** part 1's send switch, and the difference is the whole point of P2-DG-28: the
 * indicator and the resync action of the order window hang off THIS one. A node that does not emit
 * alignment offers no indicator, because it could not maintain one -- while the send action of part
 * 1 may perfectly well still be on. S127 pins that crossed combination.
 *
 * @param {boolean} inCluster Whether this installation belongs to a cluster (`frontEndConfig`)
 * @returns {boolean} Whether this node keeps sent fabrication orders aligned
 */
const useFabricationOrderAlignmentSetting = (inCluster) =>
  useClusterSwitchSetting(inCluster, FABRICATION_ORDER_ALIGNMENT_SETTING_ENDPOINT)

export default useFabricationOrderAlignmentSetting
